module.exports = __webpack_public_path__ + "img/k.cb725040.jpg";